import axios from 'axios'
import { ROLES_NOT_CHECKED_IN } from '../actionTypes'

export function clearRolesNotCheckedIn() {
  return { type: ROLES_NOT_CHECKED_IN.CLEAR }
}

const BASE = `${process.env.REACT_APP_BE_BASE_URL}/api/v1/facility-shift-users/roles-not-checked-in`

export function fetchRolesNotCheckedIn(facilityUUID) {
  return function (dispatch) {
    if (!facilityUUID) {
      return Promise.resolve({ success: true, data: [] })
    }
    dispatch({ type: ROLES_NOT_CHECKED_IN.FETCH_REQUEST })
    const accessToken = localStorage.getItem('accessToken')
    const authToken = `Bearer ${accessToken}`

    return axios
      .get(BASE, {
        params: { facility: facilityUUID },
        headers: { Authorization: authToken, Accept: 'application/json' }
      })
      .then((response) => {
        const data = response.data?.data ?? []
        const list = Array.isArray(data) ? data : []
        dispatch({ type: ROLES_NOT_CHECKED_IN.FETCH_SUCCESS, list })
        return { success: true, data: list }
      })
      .catch((error) => {
        const errorMessage = error.response?.data?.message || 'Failed to load roles'
        dispatch({ type: ROLES_NOT_CHECKED_IN.FETCH_FAILURE, error: errorMessage })
        return { success: false, error: errorMessage, data: [] }
      })
  }
}
